import React, { useEffect } from 'react';
import ReactQuill, { Quill } from 'react-quill';

import { colors } from 'global/colors';
import { QuillContainer, QuillButton } from './styles';
import './MultichoiceCreatorQuillEditor.css';

const Block = Quill.import('blots/block');

class IncorrectBlot extends Block {
  static blotName = 'incorrect';
  static tagName = 'span';
  static className = 'ql-incorrect';
}
Quill.register(IncorrectBlot);

class CorrectBlot extends Block {
  static blotName = 'correct';
  static tagName = 'span';
  static className = 'ql-correct';
}
Quill.register(CorrectBlot);

class DeleteBlot extends Block {
  static blotName = 'delete';
  static tagName = 'span';
  static className = 'ql-delete';
}
Quill.register(DeleteBlot);

const CustomToolbar = ({
  id,
  isCorrectOption,
  isIncorrectOption,
  isComment,
  onDelete,
  onOptionAnswerChange,
  isParagraph,
  disabled,
}) => (
  <QuillContainer id={`toolbar-${id}`} className="ql-toolbar ql-snow">
    <QuillContainer className="ql-formats">
      <QuillButton className="ql-bold " />
      <QuillButton className="ql-italic " />
      {!isComment && <QuillButton className="ql-image " />}
      {!isComment && !isParagraph && <QuillButton className="ql-delete" onClick={() => !disabled && onDelete()} />}
      {isCorrectOption && (
        <QuillButton className="ql-correct" onClick={() => !disabled && onOptionAnswerChange(false)} />
      )}
      {isIncorrectOption && (
        <QuillButton className="ql-incorrect" onClick={() => !disabled && onOptionAnswerChange(true)} />
      )}
    </QuillContainer>
  </QuillContainer>
);

export default function MultichoiceCreatorQuillEditor({
  value,
  id,
  placeholder,
  onChange,
  isCorrectOption,
  isIncorrectOption,
  isComment,
  onDelete,
  onOptionAnswerChange,
  isParagraph,
  height,
  minHeight,
  maxHeight,
  disabled,
}) {
  useEffect(() => {
    setTimeout(() => {
      const element = document.getElementById(`${id}`);
      const lastChild = element?.lastChild;
      if (lastChild && height) lastChild.style.height = height;
      if (lastChild && minHeight) lastChild.style.minHeight = minHeight;
      if (lastChild && maxHeight) lastChild.style.maxHeight = maxHeight;
      if (isCorrectOption) {
        const toolbarElement = document.getElementById(`toolbar-${id}`);
        toolbarElement.style.background = colors.green2;
      }
    });
  }, [id, height, isCorrectOption, maxHeight, minHeight]);

  const modules = {
    toolbar: {
      container: `#toolbar-${id}`,
    },
  };

  return (
    <>
      <CustomToolbar
        id={id}
        isCorrectOption={isCorrectOption}
        isIncorrectOption={isIncorrectOption}
        isComment={isComment}
        onDelete={onDelete}
        onOptionAnswerChange={onOptionAnswerChange}
        isParagraph={isParagraph}
        disabled={disabled}
      />
      <ReactQuill
        id={id}
        readOnly={disabled}
        modules={modules}
        placeholder={placeholder}
        value={value}
        onChange={(updatedValue, delta, source) => onChange(updatedValue, delta, source)}
        preserveWhitespace={true}
      />
    </>
  );
}
